import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Box, MobileStepper, styled } from '@mui/material';
import { COLOR_REGENT_ST_BLUE, COLOR_WHITE } from 'popTheme';

const StyledMobileStepper = styled(MobileStepper)(({ theme }) => ({
  '& .MuiMobileStepper-dot': {
    backgroundColor: COLOR_REGENT_ST_BLUE,
    width: '0.375rem',
    height: '0.375rem',
    margin: theme.spacing(0.3125),
    // Ensures full content visibility on screens < 375px width (e.g., iPhone SE 1st Gen).
    [theme.breakpoints.down(375)]: {
      margin: theme.spacing(0.21875),
    },
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0.75),
    },
  },
  '& .MuiMobileStepper-dotActive': {
    transform: 'scale(2)',
  },
}));

const Stepper = ({ activeStep, maxSteps }) => {
  const intl = useIntl();
  const messages = defineMessages({
    checkinStepperComplete: {
      id: 'checkin.stepper.complete',
      defaultMessage: "You're done!",
      description: 'Check-in stepper complete survey text',
    },
    checkinQuestionCountLabel: {
      id: 'checkin.question.count.label',
      defaultMessage: 'Question {active_Step} of {max_Steps}',
      description: 'Label indicating the question count number',
    },
  });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        pt: { xs: '1rem', md: '1.5rem' },
        pb: { xs: '2rem', md: '3rem' },
        gap: '1.875rem',
        overflowX: 'auto',
      }}
    >
      <StyledMobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        sx={{
          justifyContent: 'center',
          background: 'transparent',
        }}
      />
      <Box sx={{ color: COLOR_WHITE }}>
        {activeStep < maxSteps
          ? intl.formatMessage(messages.checkinQuestionCountLabel, {
              active_Step: activeStep + 1,
              max_Steps: maxSteps,
            })
          : intl.formatMessage(messages.checkinStepperComplete)}
      </Box>
    </Box>
  );
};

export default Stepper;
